import React from "react";
import BreadCrumbs from "@material-ui/core/Breadcrumbs";
import withStyles from "@material-ui/core/styles/withStyles";
import Badge from "@material-ui/core/Badge";
import cs from "classnames";
import moment from "moment";

import { Context } from "../../context";
import Insurance from "./steps/Insurance";
import Ordering from "./steps/Ordering";
import Payment from "./steps/Payment";
import SideBar from "./sidebar";
import Loading from "../Loading";
import * as actions from "../../actions";
import styles from "./styles";

const Forms = ({ classes, form = {}, referralLink }) => {
  const { state: { insurance, loading } = {}, dispatch } = React.useContext(
    Context
  );
  const [step, changeStep] = React.useState(0);
  const [signupTrigger, changeSignupTrigger] = React.useState(false);
  const [orderingDataSave, changeOrderingDataSave] = React.useState(false);
  React.useEffect(() => {
    actions.createInsurance(
      {
        startDate: form.from ? moment(form.from).toDate() : insurance.startDate,
        expirationDate: form.to
          ? moment(form.to).toDate()
          : insurance.expirationDate,
        locationAlpha2: "RU",
        packetId: form.packet || 2,
        isCompetition: form.competition || true,
        partnerKey: referralLink ? referralLink.partnerId : "",
        // ...(!form.coverage && {
        //   coverage: form.coverage || 0,
        // }),
        // sportKeys: ["BIATHLON", "CHESS"],
      },
      dispatch
    );
  }, []);

  // const duration = moment.duration(moment().diff(moment(insurance.startDate)))
  return (
    <div className={classes.wrap}>
      <div className={classes.header}>
        <BreadCrumbs
          classes={{
            root: classes.breadCrumbsLi,
            separator: classes.breadCrumbsSeperator,
          }}
          separator="&#9656;"
        >
          <a
            className={
              step === 0
                ? `${classes.breadCrumbsItemActive} ${classes.breadCrumbsItem}`
                : classes.breadCrumbsItem
            }
            onClick={() => changeStep(0)}
          >
            Страховка
          </a>
          <Badge
            classes={{ badge: classes.orangeBadge }}
            badgeContent={insurance.insurers.length}
          >
            <a
              className={
                step === 1
                  ? `${classes.breadCrumbsItemActive} ${classes.breadCrumbsItem}`
                  : classes.breadCrumbsItem
              }
              onClick={() => changeStep(1)}
            >
              Оформление
            </a>
          </Badge>
          <a
            className={
              step === 2
                ? `${classes.breadCrumbsItemActive} ${classes.breadCrumbsItem}`
                : classes.breadCrumbsItem
            }
            onClick={() => changeStep(2)}
          >
            Оплата
          </a>
        </BreadCrumbs>
        {/* <div className={classes.expirationDate}>
          До путешествия осталось:
          <span>
            {`
              ${Math.abs(duration.days())}
              дней
              ${Math.abs(duration.hours())}
              часов
              ${Math.abs(duration.minutes())}
              минут
            `}
          </span>
        </div> */}
      </div>
      <div
        className={cs(
          classes.content,
          insurance.loading ? classes.loading : null
        )}
      >
        <div className={classes.items}>
          <Loading loading={loading} />
          {step === 0 && <Insurance form={form || {}} classes={classes} />}
          {step === 1 && (
            <Ordering
              classes={classes}
              changeStep={changeStep}
              orderingDataSave={orderingDataSave}
              changeOrderingDataSave={changeOrderingDataSave}
            />
          )}
          {step === 2 && (
            <Payment
              classes={classes}
              changeStep={changeStep}
              signupTrigger={signupTrigger}
              changeSignupTrigger={changeSignupTrigger}
            />
          )}
        </div>
        <SideBar
          classes={classes}
          changeStep={changeStep}
          changeOrderingDataSave={changeOrderingDataSave}
          changeSignupTrigger={changeSignupTrigger}
          step={step}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(Forms);
